var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action, makeObservable } from "mobx";
import { BaseDialogState } from "../UIComponents/BaseDialog";
export class AddMemberDialogState {
    constructor() {
        this.open = false;
        this.dialogsate = new BaseDialogState();
        this.selectedcontactmap = new Map();
        this.selectedContacts = new Set();
        this.groups = [];
        this.adding = false;
        this.filterString = "";
        this.selectedEditGroup = new Set();
        this.rolesmap = new Map();
        this.letrMembers = new Set();
        makeObservable(this);
        this.dialogsate.setHeaderLabel("Contacts");
        this.dialogsate.setOkLabel("Add");
        this.dialogsate.setCancelLabel("Cancel");
        this.dialogsate.disbaleOkButton = true;
        this.dialogsate.onClose = () => {
            this.resetFilter();
        };
        this.dialogsate.onOk = () => {
            var _a;
            console.log("OK");
            console.log(this.selectedContacts);
            (_a = this.contactAddCb) === null || _a === void 0 ? void 0 : _a.call(this);
        };
    }
    addLetrMember(id) {
        this.letrMembers.add(id);
    }
    setFilterString(input) {
        this.filterString = input;
    }
    setAdding(input) {
        this.adding = input;
    }
    resetFilter() {
        this.setFilterString("");
    }
    reset() {
        this.selectedContacts.clear();
        this.selectedcontactmap.clear();
        this.resetFilter();
        this.selectedEditGroup.clear();
        this.setAdding(false);
        this.rolesmap.clear();
    }
    resetSelectedContact() {
        var _a;
        this.selectedContacts.clear();
        this.selectedcontactmap.clear();
        (_a = this.onSelecCb) === null || _a === void 0 ? void 0 : _a.call(this);
    }
    setOpen(open) {
        this.open = open;
        this.dialogsate.setOpen(open);
    }
    // maybe we should tell other side about this as well
    setSelectedContact(cont) {
        var _a;
        let selection = false;
        if (this.selectedContacts.has(cont.id)) {
            this.selectedContacts.delete(cont.id);
        }
        else {
            this.selectedContacts.add(cont.id);
            selection = true;
        }
        this.dialogsate.setDisableOkButton(!selection);
        (_a = this.onContactSelected) === null || _a === void 0 ? void 0 : _a.call(this, selection, cont);
        console.log('this.selectedContacts');
        console.log(this.selectedContacts);
    }
    setEditRoleForContact(cont, roleid) {
        this.rolesmap.set(cont.id, roleid);
        console.log('this.rolesmap');
        console.log(this.selectedContacts);
    }
    setEditPermForContact(cont) {
        var _a;
        let selection = false;
        if (this.selectedEditGroup.has(cont.id)) {
            this.selectedEditGroup.delete(cont.id);
        }
        else {
            this.selectedEditGroup.add(cont.id);
            selection = true;
        }
        (_a = this.onPermissionSelectionChanged) === null || _a === void 0 ? void 0 : _a.call(this, selection, cont);
    }
    getSelectedContact() {
        return Array.from(this.selectedcontactmap.values()).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], AddMemberDialogState.prototype, "open", void 0);
__decorate([
    observable,
    __metadata("design:type", BaseDialogState)
], AddMemberDialogState.prototype, "dialogsate", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AddMemberDialogState.prototype, "selectedcontactmap", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AddMemberDialogState.prototype, "selectedContacts", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], AddMemberDialogState.prototype, "groups", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AddMemberDialogState.prototype, "adding", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AddMemberDialogState.prototype, "filterString", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AddMemberDialogState.prototype, "selectedEditGroup", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AddMemberDialogState.prototype, "rolesmap", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AddMemberDialogState.prototype, "letrMembers", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AddMemberDialogState.prototype, "addLetrMember", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AddMemberDialogState.prototype, "setFilterString", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AddMemberDialogState.prototype, "setAdding", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AddMemberDialogState.prototype, "resetFilter", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AddMemberDialogState.prototype, "reset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AddMemberDialogState.prototype, "resetSelectedContact", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AddMemberDialogState.prototype, "setOpen", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AddMemberDialogState.prototype, "setSelectedContact", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, String]),
    __metadata("design:returntype", void 0)
], AddMemberDialogState.prototype, "setEditRoleForContact", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AddMemberDialogState.prototype, "setEditPermForContact", null);
